module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_MAINVIEW_TITLE', this.lang)))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11057832"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myAccount.vue
// module id = 871
// module chunks = 1